<template>
  <!-- active sets -->
  <f7-card strong class="card-raised mt-2" v-for="(rep_set, index) in rep_sets" @click="open_rep_picker(index)">
    <f7-card-content>
      <div class="rep-set-row">
        <strong>Set {{ (index + 1) }}</strong>
        <span>{{ rep_sets[index].reps }}x</span>
        <span>{{ rep_sets[index].weight }} kg</span>
      </div>
      <input type="hidden" readonly="readonly" :ref="'reps_' + index + '_picker'" />
    </f7-card-content>
  </f7-card>

  <!-- disabled sets -->
  <f7-card strong class="card-raised" v-for="(rep_set, index) in disabled_rep_sets" style="opacity: 0.5" @click="add_rep_set">
    <f7-card-content>
      <div class="rep-set-row">
        <span>Set {{ (index + 1 + rep_sets.length) }}</span>
        <span>{{ last_rep_set.reps }}x</span>
        <span>{{ last_rep_set.weight }} kg</span>
      </div>
    </f7-card-content>
  </f7-card>
</template>

<script>

  import Utility from "../../js/utility";
  import {f7} from "framework7-vue";

  export default {
    components: {},

    props: ['rep_sets','activity','training_session'],

    mixins: [],

    data: function () {
      return {
        // Used to store the Pickers that change the rep values.
        rep_set_pickers: [],
      };
    },

    computed: {
      disabled_rep_sets() {
        let disabled_rep_sets = [];
        // When there are less than 5 sets, we need to fill in the blanks
        if (this.rep_sets.length !== 5) {
          let number_of_disabled_sets = 5 - this.rep_sets.length;

          // Here we create an array with the right length, but the data is unimportant
          while (number_of_disabled_sets > 0) {
            disabled_rep_sets.push('');
            number_of_disabled_sets--;
          }
        }
        return disabled_rep_sets;
      },
      last_rep_set() {
        return this.rep_sets[this.rep_sets.length - 1];
      },
      activity_rep_sets() {
        return this.activity.rep_sets;
      },

      user_id() {
        return this.$store.state.current_user.data.id;
      },
    },

    created() {
      //
    },

    mounted() {
      this.reset_rep_set_pickers();
    },
    destroyed() {
      this.destroy_rep_set_pickers();
    },

    methods: {
      overwrite_rep_sets(rep_sets) {
        this.rep_sets = rep_sets;
        this.reset_rep_set_pickers();
      },
      /**
       * Updates the Rep array locally
       */
      update_reps(selectionElements, index) {
        let reps = selectionElements[0].replace('x', '');
        let weight = selectionElements[1] + selectionElements[2];

        this.rep_sets[index].reps = reps;
        this.rep_sets[index].weight = weight.replace('kg', '');
      },
      /**
       * Stores an Activity when the user is done editing
       */
      save_activity() {
        this.$store.dispatch('activities/update_only', {
          user_id: this.user_id,
          activity_id: this.activity.id,
          training_session_id: this.training_session.id,
          rep_sets: this.rep_sets,
        }).then(activity => {
          this.reset_rep_set_pickers();
        });
      },
      add_rep_set() {
        // Clone the last rep_set to the the rep_sets array
        this.rep_sets.push(Utility.clone(this.last_rep_set));

        this.$nextTick(() => {
          // And set the reps_picker
          let new_rep_index = (this.rep_sets.length - 1);
          this.initialize_rep_set_picker(new_rep_index);
          // Then auto-open it.
          this.rep_set_pickers[new_rep_index].open();
        });
      },
      delete_rep_set(index) {
        // Now we delete the rep_set index and remove the rep_picker
        this.rep_sets.splice(index, 1);

        // And finally remove the picker
        this.$nextTick(() => {
          this.reset_rep_set_pickers();
        });
      },

      /*
      * Initializes the picker(s)
      */
      reset_rep_set_pickers() {
        this.destroy_rep_set_pickers();

        this.$nextTick(() => {
          // Reset all the pickers based on the new HTML
          this.rep_set_pickers = [];
          this.rep_sets.forEach((rep_set, index) => {
            this.initialize_rep_set_picker(index);
          });
        });
      },
      destroy_rep_set_pickers() {
        this.rep_set_pickers.forEach(rep_set_picker => {
          rep_set_picker.destroy();
        });
      },
      open_rep_picker(index) {
        this.rep_set_pickers[index].open()
      },
      initialize_rep_set_picker(index) {
        let vm = this;
        let range_repititions = [];
        let range_kilograms = [];
        let count = 1;
        while (count <= 1000) {

          if (count <= 300) {
            range_kilograms.push(count);
          }
          if (count <= 225) {
            range_repititions.push(count + 'x');
          }

          count++;
        }

        this.rep_set_pickers[index] = f7.picker.create({
          inputEl: this.$refs['reps_' + index + '_picker'],
          rotateEffect: true,
          freeMode: false,
          cssClass: 'rep-picker',
          value: this.getRepSetPickerValueByIndex(index),
          updateValuesOnTouchmove: true,
          updateValuesOnMousewheel: true,
          mousewheel: true,
          openIn: 'sheet',
          cols: [
            {
              values: range_repititions
            },
            {
              textAlign: 'right',
              values: range_kilograms,
            },
            {
              textAlign: 'left',
              values: ['.0', '.125', '.25', '.375', '.5', '.675', '.75', '.875'],
            },
            {
              values: ['kg']
            }
          ],
          formatValue: (values, displayValues) => {
            return displayValues[0] + ' ' + displayValues[1] + displayValues[2] + ' ' + displayValues[3];
          },
          renderToolbar: function () {
            return '<div class="toolbar">' +
                '<div class="toolbar-inner">' +
                '<div class="left">' +
                '<a href="#" class="link toolbar-delete-activity text-danger">Verwijder</a>' +
                '</div>' +
                '<div class="center">' +
                '<strong">Set ' + (index + 1) + '</strong>' +
                '</div>' +
                '<div class="right">' +
                '<a href="#" class="link sheet-close popover-close">Done</a>' +
                '</div>' +
                '</div>' +
                '</div>';
          },
          on: {
            open: function (picker) {
              picker.$el.find('.toolbar-delete-activity').on('click', function (event) {
                event.preventDefault();
                vm.delete_rep_set(index);
              });
            },
            close: function (picker) {
              vm.update_reps(picker.value, index);
            },
            closed: function (picker) {
              vm.save_activity();
            },
          }
        });

        // this.rep_set_pickers[index] = f7.picker.create({
        //   inputEl: this.$refs['reps_' + index + '_picker'],
        //   rotateEffect: true,
        //   freeMode: false,
        //   cssClass: 'rep-picker',
        //   value: this.getRepSetPickerValueByIndex(index),
        //   updateValuesOnTouchmove: true,
        //   updateValuesOnMousewheel: true,
        //   mousewheel: true,
        //   openIn: 'sheet',


        // });
      },
      getRepSetPickerValueByIndex(index) {

        let weight = String(Utility.clone(this.rep_sets[index].weight));
        let reps = Utility.clone(this.rep_sets[index].reps);

        let kilograms = weight;
        let grams = '0';
        if (weight.includes('.')) {
          grams = weight.split('.')[1];
          kilograms = weight.split('.')[0];
        }

        return [reps + 'x', kilograms, '.' + grams, 'kg'];
      }
    },

    watch: {
      //
    }
  };
</script>
